exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".TabContents__container___F3kAN{padding:0;position:relative;width:100%;margin:0}.TabContents__content___gnA3S{display:none;line-height:inherit;padding:inherit;border:none;background:transparent}.TabContents__content___gnA3S.TabContents__active___20V-X{display:block;width:100%}", ""]);

// exports
exports.locals = {
	"container": "TabContents__container___F3kAN",
	"content": "TabContents__content___gnA3S",
	"active": "TabContents__active___20V-X"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?modules&importLoaders=1&localIdentName=[name]__[local]___[hash:base64:5]!./~/postcss-loader!./src/client/assets/TabContents/TabContents.pcss
// module id = 875
// module chunks = 0